var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 61,
    viewBox: "0 0 47 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7998 32.4042C38.7335 24.8244 44.704 21.1378 44.9771 20.9676C41.5968 15.7851 36.3553 15.079 34.5127 15.0232C30.1117 14.5348 25.8406 17.7889 23.5976 17.7889C21.3096 17.7889 17.8577 15.0679 14.1354 15.1488C9.34728 15.2269 4.86671 18.1405 2.40902 22.6644C-2.66277 31.8907 1.11788 45.4455 5.97757 52.9025C8.40875 56.5584 11.2482 60.6329 14.9652 60.4906C18.6027 60.3343 19.9601 58.0542 24.3506 58.0542C28.6986 58.0542 29.9738 60.4906 33.7651 60.3957C37.6677 60.3343 40.128 56.7286 42.4717 53.042C45.282 48.8614 46.4088 44.7339 46.4539 44.5218C46.3637 44.4938 38.874 41.4882 38.7998 32.4042ZM31.6362 10.117C33.5928 7.54672 34.9343 4.04987 34.5631 0.5C31.7316 0.631167 28.1896 2.5568 26.1508 5.0713C24.3479 7.28717 22.736 10.918 23.1549 14.3339C26.3337 14.5823 29.5974 12.6455 31.6388 10.117",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/AppStore.1170627ba83324fb6f89f7ec7a3f8bd9.svg";
export { ForwardRef as ReactComponent };